/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
import { Mat4 } from '../../../../mol-math/linear-algebra';
import { IntMap } from '../../../../mol-data/int';
import { fillIdentityTransform } from '../../../../mol-geo/geometry/transform-data';
var tmpMat = Mat4();
var StructureUnitTransforms = /** @class */ (function () {
    function StructureUnitTransforms(structure) {
        this.structure = structure;
        this.groupUnitTransforms = [];
        /** maps unit.id to offset of transform in unitTransforms */
        this.unitOffsetMap = IntMap.Mutable();
        this.groupIndexMap = IntMap.Mutable();
        this._isIdentity = undefined;
        this.version = 0;
        this.unitTransforms = new Float32Array(structure.units.length * 16);
        this.size = structure.units.length;
        this.reset(); // to set to identity
        var groupOffset = 0;
        for (var i = 0, il = structure.unitSymmetryGroups.length; i < il; ++i) {
            var g = structure.unitSymmetryGroups[i];
            this.groupIndexMap.set(g.hashCode, i);
            var groupTransforms = this.unitTransforms.subarray(groupOffset, groupOffset + g.units.length * 16);
            this.groupUnitTransforms.push(groupTransforms);
            for (var j = 0, jl = g.units.length; j < jl; ++j) {
                this.unitOffsetMap.set(g.units[j].id, groupOffset + j * 16);
            }
            groupOffset += g.units.length * 16;
        }
    }
    StructureUnitTransforms.prototype.reset = function () {
        this.version = 0;
        fillIdentityTransform(this.unitTransforms, this.size);
        this._isIdentity = true;
    };
    Object.defineProperty(StructureUnitTransforms.prototype, "isIdentity", {
        get: function () {
            if (this._isIdentity === undefined) {
                this._isIdentity = true;
                for (var i = 0, il = this.size * 16; i < il; i += 16) {
                    Mat4.fromArray(tmpMat, this.unitTransforms, i);
                    if (!Mat4.isIdentity(tmpMat)) {
                        this._isIdentity = false;
                        break;
                    }
                }
            }
            return this._isIdentity;
        },
        enumerable: false,
        configurable: true
    });
    StructureUnitTransforms.prototype.setTransform = function (matrix, unit) {
        this.version = (this.version + 1) % 0x7fffffff;
        Mat4.toArray(matrix, this.unitTransforms, this.unitOffsetMap.get(unit.id));
        this._isIdentity = undefined;
    };
    StructureUnitTransforms.prototype.getTransform = function (out, unit) {
        return Mat4.fromArray(out, this.unitTransforms, this.unitOffsetMap.get(unit.id));
    };
    StructureUnitTransforms.prototype.getSymmetryGroupTransforms = function (group) {
        return this.groupUnitTransforms[this.groupIndexMap.get(group.hashCode)];
    };
    return StructureUnitTransforms;
}());
export { StructureUnitTransforms };
